
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/routes/[slug]",
      function () {
        return require("private-next-pages/routes/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/routes/[slug]"])
      });
    }
  